import { Form, Input, InputNumber, Select, Space } from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  customerTypes: any[]; // for UpCustTypeID (parent type)
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  customerTypes,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل نوع عميل" : "إضافة نوع عميل"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item name="CustTypeID" label="كود نوع العميل">
                <InputNumber
                  placeholder="كود نوع العميل"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}
            <Form.Item
              name="CustTypeName"
              label="اسم نوع العميل"
              rules={[
                { required: true, message: "من فضلك أدخل اسم نوع العميل" },
              ]}
            >
              <Input placeholder="اسم نوع العميل" />
            </Form.Item>
            <Form.Item name="UpCustTypeID" label="نوع العميل الاعلي">
              <Select
                placeholder="نوع العميل الاعلي"
                allowClear
                options={customerTypes.map((type: any) => ({
                  label: type.CustTypeName,
                  value: type.CustTypeID,
                }))}
              />
            </Form.Item>
            {/* <Form.Item name="UpCustTypeName" label="اسم النوع الأب (اختياري)">
              <Input placeholder="اسم النوع الأب" />
            </Form.Item> */}
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
